import { useContext } from 'react';
import { ToastContext, type ToastSeverity } from '@/context/ToastContext';

export const useToast = () => {
  const context = useContext(ToastContext);
  
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }

  return {
    showSuccess: (message: string, duration?: number, title = 'Success') =>
      context.showToast(message, 'success', duration, title),
    showError: (message: string, duration?: number, title = 'Error') =>
      context.showToast(message, 'error', duration, title),
    showWarning: (message: string, duration?: number, title = 'Warning') =>
      context.showToast(message, 'warning', duration, title),
    showInfo: (message: string, duration?: number, title = 'Info') =>
      context.showToast(message, 'info', duration, title),
    showToast: (message: string, severity: ToastSeverity, duration?: number, title?: string) =>
      context.showToast(message, severity, duration, title),
  };
};
